var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagSv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sv",
    transform: "translate(7351 23024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2647",
    "data-name": "Rectangle 2647",
    width: 25,
    height: 15,
    transform: "translate(-7351 -23024)",
    fill: "#006aa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2648",
    "data-name": "Rectangle 2648",
    width: 3,
    height: 15,
    transform: "translate(-7343 -23024)",
    fill: "#fecd00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2649",
    "data-name": "Rectangle 2649",
    width: 3,
    height: 25,
    transform: "translate(-7326 -23018) rotate(90)",
    fill: "#fecd00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSv);
export default __webpack_public_path__ + "static/media/flag-sv.ac915ea1e48abd0a73c50dc62d8528ba.svg";
export { ForwardRef as ReactComponent };